import { apiClient } from "@/services/apiClient";

/**
 * A professional's second-factor state, as both detail endpoints serve it
 * (spec b8731a82).
 *
 * ONE TYPE FOR BOTH DISCIPLINES, in its own module rather than duplicated into
 * notariesService and accountantsService. The backend serves an identical block
 * from `getNotaryDetail` and `getAccountantDetail`, and a professional's
 * discipline must not decide whether their 2FA is serviceable (FM-3) — two
 * copies of this shape are two things to keep in lockstep by hand, which is
 * exactly how the notarial/accountant pair already drifts.
 */
export interface ProfessionalTotpState {
  /**
   * Confirmed only. A credential row whose `confirmedAt` is null means someone
   * was shown a seed and never proved they could use it, which is NOT enrolled
   * — and resetting it would destroy a factor they never had.
   */
  enrolled: boolean;
  confirmedAt: string | null;
  /**
   * Unused recovery codes. THE NUMBER THAT DECIDES THE CALL: with codes left,
   * the answer to "I can't get in" is "use a recovery code", and a reset
   * invalidates the very codes that would have worked (FM-4).
   */
  recoveryCodesRemaining: number;
}

/**
 * Clears a professional's second factor and ends every live session they hold.
 *
 * Lives here rather than in either discipline's service because the route is
 * `platform/professionals/...` and serves both. root or root_admin only,
 * enforced by the controller's class-level guard.
 */
export function resetProfessionalTotp(userId: string): Promise<void> {
  return apiClient
    .post(`/platform/professionals/${encodeURIComponent(userId)}/totp/reset`)
    .then(() => undefined);
}
